export default __webpack_public_path__ + "static/media/nccplogo-black.4f6ffab9.png";